/**
 * @description This is a concise representation of all the role types that matter in context of WFDSS. */
export type IWFDSSUserRoleType =
  | "ANALYST"
  | "GA_EDITOR"
  | "INCIDENT_EDITOR"
  | "SUPPORT"
  | "WFDSS_VIEWER";

  export const IWFDSSUserElevatedRoleTypeList: IWFDSSUserRoleType[] = [
    "ANALYST",
    "GA_EDITOR",
    "SUPPORT",
  ]  
